// constants/roles.ts
export const ROLES_CONFIG = {
  SUPER_USER: {
    id: 1,
    name: 'Super Admin',
    backend_name: 'superadmin',
    level: 100
  },
  COMPANY_ADMIN: {
    id: 2,
    name: 'Company Admin',
    backend_name: 'admin',
    level: 50
  },
  USER: {
    id: 3,
    name: 'User',
    backend_name: 'user',
    level: 10
  }
} as const;

export type RoleType = keyof typeof ROLES_CONFIG;
export type UserRole = 'super_user' | 'company_admin' | 'user';

// Helper functions
export const getRoleById = (id: number) => {
  return Object.values(ROLES_CONFIG).find(role => role.id === id);
};

export const getRoleByBackendName = (backendName: string) => {
  return Object.values(ROLES_CONFIG).find(
    role => role.backend_name.toLowerCase() === backendName.toLowerCase()
  );
};

export const getAllRoles = () => {
  return Object.values(ROLES_CONFIG);
};
